import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { environment } from 'src/environments/environment';
import { httpInterceptorProvider } from '../interceptor/interceptors';
import { ContactService } from '../notification/contact.service';
import { ENV_CONFIG_TOKEN, EnvConfig, EnvironmentName, getConfigValue } from '../shared/config';
import { getEnvironmentName } from '../shared/utils/env-utils';
import { CustomSnackbarComponent } from './custom-snack-bar/custom-snackbar.component';
import { RouteManagerService } from './route-manager.service';

@NgModule({
  declarations: [CustomSnackbarComponent],
  imports: [CommonModule],
  providers: [
    httpInterceptorProvider,
    ContactService,
    RouteManagerService,
    provideHttpClient(withInterceptorsFromDi()),
    { provide: ENV_CONFIG_TOKEN, useValue: getConfigValue() },
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parent: CoreModule) {
    if (parent) {
      throw new Error('Only import the CoreModule in AppModule');
    }
  }
}
